const clearSessionStorage = () => {
  sessionStorage.removeItem("selectedPostsCompany");
  sessionStorage.removeItem("selectedCategories");
  sessionStorage.removeItem("selectedPostsCompanyOrigin");
};

export default clearSessionStorage;